async function helper(context, func) {
	try {
		context.dispatch('setLoading', true);
		await func();
	} catch (error) {
		context.dispatch('setErrorMsg', error.message);
		throw error;
	} finally {
		context.dispatch('setLoading', false);
	}
}

export default helper;
